import { ERR_INVALID_ADDR, ERR_MISSING_BILLING_ADDRESS } from './ErrorCodes'
import { collateErrors as addressValidationCollateErrors } from '@ynap/address-form-v1'
import { ERR_INVALID_CARD_TYPE } from '@ynap/credit-card-form'

export default function collateErrors(values, props, json) {
    let errors
    const { messages } = props

    if (json && json.errors) {
        if (Object.keys(values).length > 0) {
            const billingAddressError = addressValidationCollateErrors(values, { ...props, addresses: props.savedAddresses }, json)

            if (billingAddressError && Object.keys(billingAddressError).length > 0) {
                errors = { billingAddress: billingAddressError, _error: billingAddressError._error }
                try {
                    Object.keys(billingAddressError).forEach((name) => {
                        if (name !== '_error') {
                            props.formRef.current.setField({ name, field: { errors: [billingAddressError[name]] } })
                        }
                    })
                } catch (err) {
                    console.error(err)
                }
            }
        }
        json.errors.forEach(({ errorKey }) => {
            switch (errorKey) {
                case ERR_INVALID_ADDR:
                    errors = { _error: messages.paymentOptionsForm.errors.invalidAddress() }
                    break
                case ERR_INVALID_CARD_TYPE:
                    errors = { _error: messages.errors.cardNotSupported() }
                    break
                case ERR_MISSING_BILLING_ADDRESS:
                    errors = { _error: messages.paymentOptionsForm.errors.invalidAddress() }
                    break
                default:
                    errors = { _error: messages.errors.paymentFailed() }
            }
        })
    }
    return errors || { _error: messages.errors.unknown() }
}
